import { Text, View } from '@react-pdf/renderer';
import { checkObjHasValues, formatShortDate } from 'utils';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';

const Experience = ({ styles, data = [], headerTitle, randomString }: any) => {
	return (
		<View style={styles.experienceField}>
			<Text style={styles.heading}>{headerTitle}</Text>

			<View style={styles.rightDetails}>
				{data?.map((res: any, idx: number) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`${idx}-temp1`} style={styles.experienceRow}>
								<View>
									<Text style={styles.experienceDate}>
										{formatShortDate(res?.startDate)} - {formatShortDate(res?.endDate)}
									</Text>
								</View>
								<View style={styles.experienceContent}>
									<Text style={styles.title}>{res?.jobTitle}</Text>
									<Text style={styles.detailSubText}>{`${res?.company} | ${res?.address}`}</Text>
									{res?.rolesDesc && (
										<View style={styles.ListBox}>
											<View style={styles.ListData}>
												<Text style={styles.Listicon}>•</Text>
												<Text style={styles.detailSubText}>
													{parse(sanitizeHtml(res.rolesDesc))}
												</Text>
											</View>
										</View>
									)}
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Experience;
